import React, { FC } from 'react';
import { WrappedFieldProps } from 'redux-form';
import { FormTextInput } from 'components/form-inputs/form-text-input/form-text-input';
import { translate, translationKeys } from 'logic/translations/translations.service';

export const NameFieldComponent: FC<WrappedFieldProps> = (props: WrappedFieldProps) => (
  <FormTextInput
    {...props}
    label={translate(translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.name)}
    placeholder={translate(
      translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.name
    )}
  />
);

export const EmailFieldComponent: FC<WrappedFieldProps> = (props: WrappedFieldProps) => (
  <FormTextInput
    {...props}
    label={translate(translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.email)}
    type={'email'}
  />
);

export const Address1FieldComponent: FC<WrappedFieldProps> = (props: WrappedFieldProps) => (
  <FormTextInput
    {...props}
    label={translate(
      translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.address1
    )}
  />
);

export const CityFieldComponent: FC<WrappedFieldProps> = (props: WrappedFieldProps) => (
  <FormTextInput
    {...props}
    label={translate(translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.city)}
  />
);

export const ZIPFieldComponent: FC<WrappedFieldProps> = (props: WrappedFieldProps) => (
  <FormTextInput
    {...props}
    label={translate(translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.zip)}
  />
);

export const VATFieldComponent: FC<WrappedFieldProps> = (props: WrappedFieldProps) => (
  <FormTextInput
    {...props}
    label={translate(translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.vat)}
  />
);
